import { defineComponent as _defineComponent } from 'vue';
import { defineComponent, ref, useCssModule, watch } from 'vue';
import { useOpenHideAnimation } from '@/shared/lib';
export default /*#__PURE__*/_defineComponent({
  __name: 'BackdropOverlay',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(__props) {
    var props = __props;
    defineComponent({
      name: 'BackdropOverlay'
    });
    var rootRef = ref();
    var $style = useCssModule();
    var _useOpenHideAnimation = useOpenHideAnimation(rootRef, !props.visible),
      animate = _useOpenHideAnimation.animate,
      isHidden = _useOpenHideAnimation.isHidden;
    watch(function () {
      return props.visible;
    }, animate);
    return {
      __sfc: true,
      props: props,
      rootRef: rootRef,
      $style: $style,
      animate: animate,
      isHidden: isHidden
    };
  }
});